import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { FaFacebookF } from "react-icons/fa";

import styles from "./ShareButtons.module.css";

function FacebookShareButton({ className }) {
  const { asPath, isReady } = useRouter();
  const [location, setLocation] = useState("");

  useEffect(() => {
    if (isReady)
      setLocation(asPath);
  }, [isReady, asPath]);

  const uri = encodeURI(`https://kvrx.org${location}`);
  return (
    <a
      href={`https://www.facebook.com/sharer/sharer.php?u=${uri}`}
      role="button"
      className={`${className} btn btn-default ${styles["share-links"]}`}
      id={styles.facebook}
      target="_blank"
      rel="noopener noreferrer"
    >
      <span>Share</span> <FaFacebookF />
    </a>
  );
}

export default FacebookShareButton;
